import {
    GET_PAYMENT_LISTING,
    GET_PAYMENT_LISTING_SUCCESS,
    GET_PAYMENT_LISTING_FAIL,
    ADD_PAYMENT,
    ADD_PAYMENT_SUCCESS,
    ADD_PAYMENT_FAIL,
    DELETE_PAYMENT,
    DELETE_PAYMENT_SUCCESS,
    DELETE_PAYMENT_FAIL,
    UPDATE_PAYMENT,
    UPDATE_PAYMENT_SUCCESS,
    UPDATE_PAYMENT_FAIL,
    RESET_PAYMENT_STATE,
    GET_PAYMENT_DETAILS,
    GET_PAYMENT_DETAILS_SUCCESS,
    GET_PAYMENT_DETAILS_FAIL,
    UPDATE_PAYMENT_CONFIGURATION,
    UPDATE_PAYMENT_CONFIGURATION_SUCCESS,
    UPDATE_PAYMENT_CONFIGURATION_FAIL,
} from "./actionTypes";

export const getPaymentListing = payment => ({
    type: GET_PAYMENT_LISTING,
    payload: payment,
});

export const getPaymentListingSuccess = payment => ({
    type: GET_PAYMENT_LISTING_SUCCESS,
    payload: payment,
});

export const getPaymentListingFail = error => ({
    type: GET_PAYMENT_LISTING_FAIL,
    payload: error,
});

export const getPaymentDetails = payment => ({
    type: GET_PAYMENT_DETAILS,
    payload: payment,
});

export const getPaymentDetailsSuccess = payment => ({
    type: GET_PAYMENT_DETAILS_SUCCESS,
    payload: payment,
});

export const getPaymentDetailsFail = error => ({
    type: GET_PAYMENT_DETAILS_FAIL,
    payload: error,
});

export const updatePayment = payment => ({
    type: UPDATE_PAYMENT,
    payload: payment,
});

export const updatePaymentSuccess = payment => ({
    type: UPDATE_PAYMENT_SUCCESS,
    payload: payment,
});

export const updatePaymentFail = error => ({
    type: UPDATE_PAYMENT_FAIL,
    payload: error,
});

export const addPayment = payment => ({
    type: ADD_PAYMENT,
    payload: payment,
});

export const addPaymentSuccess = payment => ({
    type: ADD_PAYMENT_SUCCESS,
    payload: payment,
});

export const addPaymentFail = error => ({
    type: ADD_PAYMENT_FAIL,
    payload: error,
});

export const deletePayment = payment => ({
    type: DELETE_PAYMENT,
    payload: payment,
});

export const deletePaymentSuccess = payment => ({
    type: DELETE_PAYMENT_SUCCESS,
    payload: payment,
});

export const deletePaymentFail = error => ({
    type: DELETE_PAYMENT_FAIL,
    payload: error,
});

export const updatePaymentConfiguration = payment => ({
    type: UPDATE_PAYMENT_CONFIGURATION,
    payload: payment,
});

export const updatePaymentConfigurationSuccess = payment => ({
    type: UPDATE_PAYMENT_CONFIGURATION_SUCCESS,
    payload: payment,
});

export const updatePaymentConfigurationFail = error => ({
    type: UPDATE_PAYMENT_CONFIGURATION_FAIL,
    payload: error,
});

//reset
export const resetPaymentState = () => {
    return {
        type: RESET_PAYMENT_STATE,
    }
}

